import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const FixturesandProperty = ({ contract }: { contract: Contract }) => {
  return (
    <View>
      <Text style={styles.title}>Fixtures and Personal Property</Text>

      <Text style={styles.text}>
        1. It is possible for certain items of personal property to be so
        integrated into the Property that they become fixtures and will be
        regarded as part of the Property and therefore included in a sale.
        <Text style={styles.InfoText}>
          Buyer and Seller are encouraged to be specific when negotiating what
          items will be included or excluded in this sale.
        </Text>
      </Text>
      <Text style={styles.text}>
        2.{' '}
        <Text style={styles.bold}>
          INCLUDED in this sale, unless otherwise stated
        </Text>
        , are all existing items permanently installed in or on the Property,
        free of liens, and other items including plumbing; heating; gas
        fireplace logs; radiator covers; hardwired security systems;
        thermostats; lighting fixtures (including chandeliers and ceiling fans);
        pools, spas and hot tubs (including covers and cleaning equipment);
        electric animal fencing systems (excluding collars); garage door openers
        and transmitters; mounting brackets and hardware for television and
        sound equipment; unpotted shrubbery, plantings and trees; smoke
        detectors and carbon monoxide detectors; sump pumps; storage sheds;
        fences; mailboxes; wall to wall carpeting; existing window screens,
        storm windows and screen/storm doors; window covering hardware
        (including rods and brackets), shades and blinds; awnings; central
        vacuum system (with attachments); built-in air conditioners; built-in
        appliances; the range/oven; dishwashers; trash compactors; any remaining
        heating and cooking fuels stored on the Property at the time of
        settlement; and, if owned, solar panels, windmills, water treatment
        systems, propane tanks and satellite dishes. Unless stated otherwise,
        the following items are included in the sale, at no additional cost:{' '}
        <Text style={styles.InfoText}>
          {contract?.offerSpecifics.personalProperty}
        </Text>
      </Text>
      <Text style={styles.text}>
        3. The following items are{' '}
        <Text style={styles.bold}>not owned by Seller</Text> and may be subject
        to a lease or other financing agreement. Contact the provider/vendor for
        more information (e.g., solar panels, windmills, water treatment
        systems, propane tanks and satellite dishes):{' '}
        <Text style={styles.InfoText}>
          {contract?.offerSpecifics.leasedProperty}
        </Text>
      </Text>
      <Text style={styles.text}>
        <Text style={styles.bold}>4. EXCLUDED fixtures and items:</Text>{' '}
        <Text style={styles.InfoText}>
          {contract?.offerSpecifics.excludedPersonalItem}
        </Text>
      </Text>
    </View>
  );
};

export default FixturesandProperty;
